import React from 'react';
import { DialogProps } from '@material-ui/core';
import { IJournalEquipmentItem } from '../../interfaces';
import BaseJournalEquipmentItemDialog from './BaseJournalEquipmentItemDialog';

interface IProps {
  journalEquipmentItem: IJournalEquipmentItem | null;
  disabled: boolean;
  onClose(): void;
  onSubmitJournalEquipmentItem(journalEquipmentItem: IJournalEquipmentItem): void | Promise<void>;
}

const JournalEquipmentItemSaveDialog: React.FC<IProps & Pick<DialogProps, 'open'>> = ({
  open,
  journalEquipmentItem,
  disabled,
  onClose,
  onSubmitJournalEquipmentItem,
}) => {
  const title = journalEquipmentItem?.journalEquipmentItemId
    ? 'Обновить запись в журнале учета оборудования'
    : 'Добавить запись в журнале учета оборудования';

  const submitButtonText = journalEquipmentItem?.journalEquipmentItemId ? 'Обновить' : 'Добавить';

  return (
    <BaseJournalEquipmentItemDialog
      open={open}
      title={title}
      submitButtonText={submitButtonText}
      equipmentItem={journalEquipmentItem}
      disabled={disabled}
      onClose={onClose}
      onSubmit={onSubmitJournalEquipmentItem}
    />
  );
};

export default JournalEquipmentItemSaveDialog;
